module.exports = __webpack_public_path__ + "static/9-f914bc5b5063e6ab34d6188ac7b333e9.jpg";